import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { TAgreement } from '@cian/newbuilding-flat-view-order-component';

import { TAddLegalAgreementRequest } from '../../../repositories/users-features/v1/add-legal-agreement';
import { resolveAddLegalAgreementBatched } from '../../../services/addLegalAgreement';

interface ISaveLegalAgreementsParams {
  httpApi: IHttpApi;
  logger: ILogger;
  acceptedAgreements: TAgreement[];
  marketingAgreementVersion: number;
  personalDataAgreementVersion: number;
  source: string;
}

export function saveLegalAgreements({
  httpApi,
  logger,
  acceptedAgreements,
  marketingAgreementVersion,
  personalDataAgreementVersion,
  source,
}: ISaveLegalAgreementsParams): void {
  if (acceptedAgreements.length === 0) {
    return;
  }

  const fetchParams: TAddLegalAgreementRequest[] = acceptedAgreements.map(agreementType => {
    let agreementVersion: number;
    switch (agreementType) {
      case 'marketing':
        agreementVersion = marketingAgreementVersion;
        break;
      case 'personalDataDemand':
        agreementVersion = personalDataAgreementVersion;
        break;
      default:
        agreementVersion = 1;
    }

    return {
      agreementType,
      agreementVersion,
      status: 'accepted',
      source,
    };
  });

  resolveAddLegalAgreementBatched({ httpApi, logger }, fetchParams);
}
